interface TextFieldProps {
    name: string;
    label: string;
    value: string | null;
    onChange: (name: string, value: string) => void;
    required?: boolean;
    maxLength?: number | null;
    hiddeLabel?: boolean;
    isDisabled?: boolean;
    ref?: React.MutableRefObject<null>;
}

export const TextField = ({
    name,
    label,
    value,
    required = false,
    onChange,
    maxLength = 50,
    hiddeLabel = false,
    isDisabled = false,
    ref = undefined,
}: TextFieldProps) => {
    const onFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        event.target.classList.add('touched');
    };

    return (
        <div className='mb-2'>
            {!hiddeLabel && (
                <label className='form-label'>
                    {label} {required && <span className='text-danger'>*</span>}
                </label>
            )}
            <input
                id={name}
                key={name}
                type='text'
                name={name}
                onFocus={onFocus}
                className='form-control'
                required={required}
                value={value ?? ''}
                onChange={(e) => onChange(name, e.target.value)}
                maxLength={maxLength ?? 50}
                disabled={isDisabled}
                ref={ref}
            />
        </div>
    );
};
